import type { ReactNode } from "react";

export function sampleSeriesToDaily(
  points: { x: number; y: number }[]
): { x: number; y: number }[] {
  const byDay = new Map<string, { x: number; y: number }>();
  for (const p of points) {
    const day = new Date(p.x).toISOString().slice(0, 10);
    byDay.set(day, p); // last point of each day wins
  }
  return [...byDay.values()];
}

export interface WidgetDataTableColumn {
  key: string;
  label: string;
  align?: "left" | "right";
}

export interface WidgetDataTableProps {
  columns: WidgetDataTableColumn[];
  rows: Array<Record<string, ReactNode>>;
  emptyLabel?: string;
}

export default function WidgetDataTable({ columns, rows, emptyLabel }: WidgetDataTableProps) {
  if (rows.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        {emptyLabel ?? "—"}
      </div>
    );
  }
  return (
    <div className="h-full overflow-auto">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-card">
          <tr className="border-b border-border/60">
            {columns.map((col) => (
              <th
                key={col.key}
                className={`px-3 py-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground ${col.align === "right" ? "text-right" : "text-left"}`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-b border-border/40 last:border-b-0">
              {columns.map((col) => (
                <td
                  key={col.key}
                  className={`px-3 py-2 ${col.align === "right" ? "text-right font-mono" : "text-left"}`}
                >
                  {row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
